import React from 'react';
import type { KaliaResource } from './types';

type Props = {
    resources: KaliaResource[];
    columnWidth: number;
};

function KaliaCalendarHeader({ resources, columnWidth }: Props) {
    const headerWidth = resources.length * columnWidth + 56;
    return (
        <div className='sticky top-0 z-40 flex bg-white border-b border-gray-300' style={{ minWidth: headerWidth }}>
            <div className='sticky left-0 z-50 bg-white shrink-0 border-r border-gray-300' style={{ width: 56 }} />
            {resources.map((resource) => (
                <div
                    key={resource.id}
                    className='shrink-0 border-r border-gray-300 px-2 py-2 text-center'
                    style={{ width: columnWidth }}
                >
                    <span className='text-xs font-semibold text-gray-800 truncate block'>
                        {resource.title}
                    </span>
                </div>
            ))}
        </div>
    );
}

export default React.memo(KaliaCalendarHeader);
